import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "root"
};
import TransitionRouteView from '@/common/components/TransitionRouteView.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(TransitionRouteView)]);
    };
  }
});